<template>
  <v-container class="pa-0 ma-0" style="height: 401px">
    <v-card outlined class="pa-4 ma-0">
      <!-- Global info-->
      <v-container class="chart-header d-flex justify-space-between pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-2">
          {{ $t("compare_sell_profit_trend") }}
        </v-card-text>
      </v-container>

      <!-- area chart-->
      <apexchart
        v-if="hasData"
        type="area"
        height="337"
        width="100%"
        :options="chartOptions"
        :series="chartSeries"
      />
      <v-container
        v-else
        class="pa-0 ma-0 d-flex flex-column align-center justify-center"
        style="height: 337px"
      >
        <img
          :src="require('@/assets/dashboard/no-data(3).png')"
          max-width="100"
          height="100"
          contain
          class="mb-3"
        />
        <v-card-text class="text-body-2 grey--text text-center">
          {{ $t("nothing-for-render") }}
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      chartRawData: {},
      loading: false,
    };
  },
  computed: {
    hasData() {
      return this.chartSeries[0].data.some((val) => val > 0);
    },
    lastSixMonthsData() {
      return Object.values(this.chartRawData || {}).slice(-6);
    },
    profitSeriesData() {
      return this.lastSixMonthsData.map((item) => {
        const profit = item.monthlyInvoices?.profit;
        if (!profit) return 0;

        const income = profit.income ?? 0;
        const cost = profit.cost ?? 0;

        return income;
      });
    },
    chartSeries() {
      return [
        {
          name: this.$t("sell"),
          data: this.lastSixMonthsData.map(
            (item) => item.monthlyInvoices?.sell?.amount ?? 0
          ),
        },
        {
          name: this.$t("profit"),
          data: this.profitSeriesData,
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: "area",
          toolbar: { show: false },
          fontFamily: "IRANSans",
        },

        stroke: {
          curve: "smooth",
          // width: 2,ّ
          width: [2.5, 2],
          dashArray: [0, 2],
        },

        colors: ["#3B82F6", "#10B981"],

        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            opacityFrom: 0.45,
            opacityTo: 0.05,
          },
        },
        markers: {
          size: [0, 4],
          strokeColors: ["#3B82F6", "#10B981"],
          strokeWidth: 2,
          hover: {
            size: 4,
          },
        },
        xaxis: {
          categories: this.lastSixMonthsData.map((item) => item.label),
          axisBorder: { show: false },
          axisTicks: { show: false },
        },

        yaxis: {
          labels: {
            show: true,
            style: {
              fontSize: "10px",
            },
            offsetX: this.$vuetify.rtl ? -80 : 0,
            formatter: (value) => {
              return `${this.$numberFormat(value)} ${this.$store.state.currency.name}`;
            },
          },
        },

        grid: {
          strokeDashArray: 4,
        },

        legend: {
          position: "bottom",
          horizontalAlign: "center",
        },

        tooltip: {
          y: {
            formatter: (value) =>
              `${value.toLocaleString()} ${this.$store.state.currency.name}`,
          },
        },

        dataLabels: {
          enabled: false,
        },
      };
    },
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.getSellProfitByMonth(newVal);
      },
    },

    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getSellProfitByMonth(newVal);
      },
    },
  },
  mounted() {
    this.getSellProfitByMonth();
  },
  methods: {
    getSellProfitByMonth(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/invoice-by-month", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          app.chartRawData = response.data?.data || {};
        })
        .catch((error) => {
          console.error("compare sell and profit chart error:", error);
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .apexcharts-legend.position-bottom .apexcharts-legend-series,
::v-deep .apexcharts-legend.position-top .apexcharts-legend-series {
  gap: 0.5rem;
  padding-top: 10px;
}
.chart-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
